export default __webpack_public_path__ + "static/media/KingStake.49ed8fa4.png";